import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Styled from "./styles";
import { useLogout } from "../../../services/mutations";
import { isUserLoggedIn } from "../../../utils/helpers";
import { ASSETS } from "../../../utils/config";
import { logout } from "../../../redux/actions";
import { TextView } from "@components";
import ReferralsIcon from "assets/images/referrals-icon.svg";
import grid from "@assets/images/grid.svg";
import log_out from "@assets/images/log_out.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useLocation } from "react-router-dom";
function ActionsDropdown({
  setModalOpen = null,
  setOnLeave = null,
  onLike = () => {},
  onClone = () => {},
  onShare = () => {},
  isLiked = false,
}) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [clicked, setClicked] = useState(false);
  const location = useLocation();

  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
        setClicked(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleDropdownItemClick = (action) => {
    // if (setOnLeave && setModalOpen) {
    //   setOnLeave(() => action);
    //   setModalOpen(true);
    // } else {
    action();
    // }
  };

  return (
    <Styled.UserContainer
      clicked={clicked}
      ref={dropdownRef}
      onClick={() => {
        setClicked(true);
        setShowDropdown(!showDropdown);
        // isUserLoggedIn() && setShowDropdown(!showDropdown);
      }}
    >
      <MoreVertIcon style={{ fontSize: "20px" }} />
      {showDropdown && (
        <Styled.Dropdown>
          <Styled.DropdownItem onClick={() => handleDropdownItemClick(onShare)}>
            Share
          </Styled.DropdownItem>
          <Styled.DropdownItem onClick={() => handleDropdownItemClick(onClone)}>
            Clone
          </Styled.DropdownItem>

          <Styled.DropdownItem onClick={() => handleDropdownItemClick(onLike)}>
            {isLiked ? "Unlike" : "Like"}
          </Styled.DropdownItem>
        </Styled.Dropdown>
      )}
    </Styled.UserContainer>
  );
}

export default ActionsDropdown;
